import { Box } from "@chakra-ui/react";
import type { SbEditableComponentProps } from "types/storyblok";
import type { SpacerProps } from "./types";

export const Spacer = ({ hDesktop, hMobile, hTablet, sbEditable }: SbEditableComponentProps<SpacerProps>) => {
  const margin = hTablet === "auto" || hMobile === "auto" || hDesktop === "auto" ? "auto" : 0;
  return <Box h={{ base: hMobile, md: hTablet, xl: hDesktop }} my={margin} {...sbEditable} />;
};
